<script>
	// User Information card, extracted from dashboard.svelte so the dashboard
	// and integrations pages render the same card. Data comes from the shared
	// stores (src/stores/userInfo.js + subscriptionType from integrations.js)
	// so each fetch happens once per page load regardless of consumers.
	import { goto } from '@roxi/routify';
	import { username, accountValid, lifetimeValid, accountValidityError,
		periodDownloads, userInfoLoaded, loadUserInfo } from '../stores/userInfo.js';
	import { subscriptionType, loadFeatures } from '../stores/integrations.js';

	loadUserInfo();
	loadFeatures();
</script>

<div class="px-8 py-6 lg:px-16 lg:py-16 card">
	<p class="text-2xl font-semibold text-blue-900 mb-8">User Information</p>
	<div class='text-xl font-normal mb-6'>
		{#if $username}
		<p>Hi {$username}</p>
		{/if}
		{#if $userInfoLoaded}
		<p>Account Status: {$accountValid ? 'Valid' : 'Invalid'}</p>
		<p class="text-red-500">{$accountValidityError}</p>
		{/if}
		<p class="{$subscriptionType ? "" : "hidden"}">Subscription Type: {$subscriptionType}</p>
		{#if $accountValid && $subscriptionType == "NONE"}
		<p>Subscription cancelling at the end of this period.</p>
		{/if}
		{#if $lifetimeValid}
		<p>You have an enterprise account.</p>
		{/if}
		<br>
		{#if $periodDownloads !== null}
			<p>You have downloaded {$periodDownloads} {$periodDownloads == 1 ? 'file' : 'files'} this period.</p>
		{/if}
	</div>
	<div class='flex-col space-y-4'>
		<button on:click={$goto('/user-info-menu')}
		class="px-4 pb-2.5 pt-1.5 text-xl rounded-md bg-blue-500 hover:bg-blue-700 cursor-pointer text-gray-100 font-semibold border-none shadow-sm">
		Edit User Information</button>
	</div>
</div>
